{
  "verified": "Проверено",
  "iv_status": {
    "verified": "Проверено",
    "pending": "В очакване",
    "attention": "Внимание"
  },
  "zoom_in": "Увеличаване на мащаба",
  "zoom_out": "Увеличаване на мащаба",
  "rotate": "Завъртете",
  "close": "Затвори",
  "esc_to_close": "Натиснете ESC, за да затворите",
  "play": "Играйте",
  "pause": "Пауза",
  "mute": "Заглушаване на звука",
  "unmute": "Отмяна на звука",
  "enter_full_screen": "Въвеждане на цял екран",
  "exit_full_screen": "Излизане от цял екран",
  "video_not_supported": "Браузърът ви не поддържа тага за видео.",
  "skip_forward": "Прескачане напред",
  "skip_backward": "Пропускане назад",
  "loading": "Зареждане на",
  "loading_video": "Зареждане на видео...",
  "loading_data_description": "Моля, изчакайте, докато заредим данните ви. Това няма да отнеме много време.",
  "no_results": "Няма резултати",
  "nothing_found": "Нищо не е намерено",
  "save_changes": "Запазване на промените",
  "saved_exclamation": "Спасено!",
  "saving": "Спестяване на",
  "validating": "Утвърждаване на",
  "error": "Грешка",
  "optional": "По избор",
  "search_property": "Търсене на имот",
  "reset_search": "Нулиране на търсенето",
  "no_items_to_show": "Няма елементи за показване",
  "showing_range_of_total_items": "Показване на {{range}} от {{total}} елементи",
  "rows_per_page": "Редове на страница",
  "page_of_pages": "Страница {{page}} от {{pages}}",
  "go_to_first_page": "Отидете на първа страница",
  "go_to_previous_page": "Отидете на предишната страница",
  "go_to_next_page": "Отидете на следващата страница",
  "go_to_last_page": "Отидете на последната страница",
  "sort_in_asc": "Сортиране във възходящ ред",
  "sort_in_desc": "Сортиране в низходящ ред",
  "sort_a_z": "Сортиране A → Z",
  "sort_z_a": "Сортиране Z → A",
  "clear_sorting": "Ясно сортиране",
  "reach_us_at_email": "Обърнете се за помощ към support@chekin.com",
  "please_wait": "Моля, изчакайте",
  "feature_coming_soon": "Очаквайте скоро",
  "feature_coming_soon_description": "Тази функция е в процес на разработка и ще бъде налична скоро. Следете за актуализации!",
  "download_all": "Изтегляне на всички",
  "entry_forms": "Формуляри за участие",
  "tutorial": "Учебник",
  "liveness_video": "Видеоклип за жизненост",
  "beta": "Бета",
  "reviews": "Отзиви",
  "learn_more": "Научете повече",
  "this_cannot_be_reverted": "Това не може да бъде върнато.",
  "delete": "Изтриване на",
  "cancel": "Отмяна на",
  "you_have_made_changes": "Направили сте промени",
  "would_you_like_to_save_them": "Искате ли да ги запазите?",
  "save": "Запазете",
  "dont_save": "Не запазвайте",
  "copied_exclamation": "Копирано!",
  "search_placeholder": "Търсене...",
  "type_to_search": "Напишете, за да търсите...",
  "loading_more": "Зареждане...",
  "no_options": "Няма опции",
  "select_option": "Изберете опция",
  "clear_all": "Изчистване на всички",
  "remove_item": "Премахване на {{label}}",
  "upload_file": "Качване на файл",
  "download_attachment": "Изтегляне на прикачен файл",
  "remove_file": "Премахване на файл",
  "open_calendar": "Отворен календар",
  "clear_dates": "Изчистване на датите",
  "select_dates": "Изберете дати",
  "pick_date_range": "Изберете диапазон от дати",
  "from": "От",
  "to": "За",
  "pick_month": "Изберете месец",
  "pick_date": "Изберете дата",
  "month": "Месец",
  "day": "Ден",
  "year": "Година",
  "done": "Готово",
  "wrong_period_of_dates": "Избраният период е невалиден",
  "date_range_max_days_error_one": "Обхватът не може да надвишава {{count}} ден",
  "date_range_max_days_error_other": "Обхватът не може да надвишава {{count}} дни",
  "date_range_min_days_error_one": "Обхватът трябва да бъде поне {{count}} ден",
  "date_range_min_days_error_other": "Диапазонът трябва да бъде най-малко {{count}} дни",
  "past_dates": "Датата не може да бъде преди {{minDate}}",
  "future_dates": "Датата не може да е след {{maxDate}}",
  "signature_placeholder_text": "Подпишете се в това поле.<br/> Използвайте пръста си.<br/> Докоснете, за да започнете.",
  "open_devices_camera": "Отваряне на камерата на устройството",
  "place_document_inside_frame": "Поставете документа в рамката",
  "close_other_application_that_may_be_using_your_camera": "Затваряне на други приложения, които може да използват камерата",
  "if_you_use_external_camera_disconnect_and_reconnect": "Ако използвате външна камера, изключете я и я свържете отново",
  "close_the_browser_re_open_it": "Затворете браузъра и го отворете отново",
  "camera_errors": {
    "experiencing_camera_issues": "Имате проблеми с камерата?",
    "chekin_cant_use_your_camera": "Chekin не може да използва вашата камера",
    "please_try_a_different_browser": "Камерата ви не работи в този браузър. Моля, опитайте да отворите връзката в друг браузър.",
    "permissions_denied": "Разрешението е отказано",
    "camera_permissions_denied": "Камерата не се отваря? Уверете се, че сте разрешили на браузъра да използва камерата.",
    "no_camera_device_found": "Не е намерено устройство на камерата. Моля, свържете камера.",
    "constraints_camera_error": "Ограниченията не могат да бъдат изпълнени от наличните устройства.",
    "safari_camera_error": "Safari не може да отговори на изискванията на камерата",
    "try_chrome_or_firefox": "Моля, опитайте с Chrome или Firefox"
  },
  "clear": "Clear",
  "show_less": "Покажи по-малко",
  "show_more": "Покажи повече",
  "tap_here_to_sign": "Докоснете тук, за да подпишете",
  "click_here_to_sign": "Кликнете тук, за да подпишете",
  "prefix": "Префикс",
  "prefix_required": "Изисква се префикс",
  "reset": "Нулиране на",
  "show_password": "Показване на паролата",
  "hide_password": "Скриване на паролата",
  "increment": "Увеличаване на",
  "decrement": "Намаление",
  "create_option": "Създаване на \"{{input}}\"",
  "year_out_of_range": "Годината трябва да е между {{min}} и {{max}}",
  "clear_date": "Ясна дата",
  "select_date": "Изберете дата",
  "draw_signature_here": "Поставете подписа си тук",
  "signature_hint": "Използвайте мишката или пръста си",
  "clear_signature": "Ясен подпис",
  "draw_signature_here_mobile": "Нарисувайте подписа си",
  "signature_hint_mobile": "Използвайте пръста си",
  "camera_access_needed": "Необходим е достъп до камерата",
  "camera_access_needed_text": "Разрешете достъп до камерата, за да направите снимката. Ако достъпът е блокиран, разрешете камерата в настройките на браузъра си и опитайте отново.",
  "dialog": "Диалог"
}
